export default class Testimonials {
    public static init(): void {
        $(window).on('load', () => {
            let $list = $('.testimoniallist');
            let $items = $('.testimoniallist__item', $list);

            $items.each(function () {
                let $item = $(this);
                let $wrap = $('.testimonial__wrap', $item);
                let $more = $('.testimonial__more', $item);

                $item.data('h', $wrap.height());

                $more.click((e) => {
                    e.preventDefault();

                    if ($item.hasClass('testimonial--opened')) {
                        $item.removeClass('testimonial--opened');
                        $item.addClass('testimonial--closed');
                        $wrap.css('height', 100);
                    } else {
                        $item.removeClass('testimonial--closed');
                        $item.addClass('testimonial--opened');
                        $wrap.css('height', $item.data('h'));

                    }
                });

                $item.addClass('testimonial--closed');
                $wrap.css('height', 100);
            });

            $list.addClass('testimoniallist--inited');
        });
    }
}
